module.exports = __webpack_public_path__ + "static/img/video_default_.cf43dfb4.png";